// client/src/components/Register.js
import React, { useState } from 'react';
import axios from 'axios';
import { Form, Button } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';

const Register = () => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [avatar, setAvatar] = useState(null);
  const [redirect, setRedirect] = useState(false);
  const [error, setError] = useState(''); // Added for better error display

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); // Clear previous errors
    const formData = new FormData();
    formData.append('login', login);
    formData.append('password', password);
    formData.append('phone', phone);
    if (avatar) formData.append('avatar', avatar);

    try {
      await axios.post('/auth/register', formData);
      alert('Registration successful! Please log in.');
      setRedirect(true);
    } catch (error) {
      console.error(error);
      // Extract the exact error message from the backend if it exists
      const backendError = error.response?.data?.error || 'Registration failed. Please try again.';
      setError(backendError);
    }
  };

  if (redirect) {
    return <Navigate to="/login" />;
  }

  return (
    <Form onSubmit={handleSubmit}>
      {/* Show error message if it exists */}
      {error && <div className="alert alert-danger">{error}</div>}

      <Form.Group controlId="formLogin" className="mb-3">
        <Form.Label>Login</Form.Label>
        <Form.Control type="text" value={login} onChange={(e) => setLogin(e.target.value)} required />
      </Form.Group>

      <Form.Group controlId="formPassword" className="mb-3">
        <Form.Label>Password</Form.Label>
        <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
      </Form.Group>

      <Form.Group controlId="formPhone" className="mb-3">
        <Form.Label>Phone</Form.Label>
        <Form.Control type="text" value={phone} onChange={(e) => setPhone(e.target.value)} />
      </Form.Group>

      <Form.Group controlId="formAvatar" className="mb-3">
        <Form.Label>Avatar</Form.Label>
        <Form.Control
          type="file"
          onChange={(e) => setAvatar(e.target.files[0])}
          accept="image/*" // Restricts file picker to only images
        />
      </Form.Group>

      <Button variant="primary" type="submit">Register</Button>
    </Form>
  );
};

export default Register;